<div class="filter-area">
	<div class="filter-wrapper">
		<div class="toggle-area">
			<span>Daily</span>
			<label class="switch">
				<input type="checkbox" [(ngModel)]="isMonthly"
					(change)="reportData = []; tempSelectedDate = ''; selectedMonth=''">
				<span class="slider round"></span>
			</label>
			<span>Monthly</span>
		</div>
		<div *ngIf="!isMonthly">
			<input type="date" class="input" [(ngModel)]="tempSelectedDate" [max]="maxDate" (change)="validateDate()">
		</div>
		<div *ngIf="isMonthly">
			<div>
				<select class="input" [(ngModel)]="tempSelectedMonth">
					<option value="">Select month</option>
					@for (case of monthsList; track case){
					<option [ngValue]="case">{{case.month}}</option>
					}
				</select>
			</div>
		</div>
		<div>
			<select class="input" [(ngModel)]="selectedUser">
				<option value="">Select user</option>
				@for (case of coderNameList; track case){
				<option [value]="case">{{case}}</option>
				}
			</select>
		</div>
		<div>
		  <app-dropdown [placeHolder]="'Select Case name'" [hasFilter]="true" [selected]="selectedCase"
			[list]="sharedService.caseNames()" (onSelect)="saveCase($event)"  [containerWidth]="'300px'" [dropdownSize]="dropdownSize"  ></app-dropdown>
		</div>
		<div class="btn-wrapper">
			<button class="btn btn-secondary" (click)="resetAccuracyReportFilter()">Reset</button>
		</div>
		<div class="btn-wrapper">
			<button class="btn btn-primary" (click)="applyAccuracyReportFilter()">Apply</button>
		</div>
	</div>
	@if (reportData.length>0) {
		<div class="export-wrapper">
			<!-- Export button can be added if needed -->
		</div>
	}
</div>

<div class="grid">
	<ng-container>
		<div class="grid-header">Total Packages</div>
		<div class="grid-header">Total Documents</div>
		<div class="grid-header">Auto Classified Documents</div>
		<div class="grid-header">Overridden Documents</div>
		<div class="grid-header">Classification Accuracy (%)</div>
		<div class="grid-header">Source System</div>
	</ng-container>
	@for(report of reportData; track report.sourceSystem; let i = $index) {
	<ng-container>
		<div>{{report.totalPackages}}</div>
		<div>{{report.totalDocuments}}</div>
		<div>{{report.autoClassifiedDocuments}}</div>
		<div>{{report.overriddenDocuments}}</div>
		<div>{{report.classificationAccuracy | number:'1.2-2'}}</div>
		<div>{{report.sourceSystem}}</div>
	</ng-container>
	}
	@empty {
	<div class="no-records">No records</div>
	}
</div>
<app-pagination [totalPackageLength]="totalRecords" [pageSize]="pageSize" [listCount]="reportData.length"
	(loadPageEmit)="paginationNavigation($event)"></app-pagination>
